import { $, $$ } from '@zimpa/dom';

const TOGGLE_SELECTOR = '.js-focus-on-input';

export function focusOnInput(): void {
    $$<HTMLElement>(TOGGLE_SELECTOR).forEach((trigger): void => {
        const id = trigger.getAttribute('data-target-input');

        if (id === null) {
            return;
        }

        const target: HTMLElement | undefined = $<HTMLElement>(id);

        if (target === undefined) {
            return;
        }

        trigger.addEventListener('click', (event): void => {
            target.focus();
        });
    });
}
